import Vue from 'src/views/base'
import { Component } from 'vue-property-decorator'
import template from './registry.vue'
import * as customRules from 'common/validator'
import { Store as CommonStore } from 'store/modules/common'
import { Store as UserStore } from 'store/modules/user'
import newHeader from 'src/views/components/new-header'
// import Cookies from 'js-cookie'

/**
 * 个人用户注册
 *
 * @export
 * @class Registry
 * @extends {Vue}
 */
@Component({
    name: 'registry',
    mixins: [template],
    components: {
        newHeader
    }
})

export default class Registry extends Vue {
    @CommonStore.action('setPageParams') setPageParams
    @UserStore.action('setUser') setUser
    formName = 'registryForm'
    form = {
        username: '',
        mobile: null,
        mobileVCode: null,
        agree: null
    }
    disabledSubmit = true
    disabled = false
    timer = null
    count = 60
    verifyCodeText = '获取验证码'
    originVerifyCode = null
    rules = {
        validateAgree: (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请勾选同意条款'))
            }
            callback()
        },
        validateUserName: (rule, value, callback) => {
            if (this.utils.isEmpty(value)) {
                return callback(new Error('请输入用户名'))
            }
            callback()
            // this.api.userApi.checkNameExisit({ userName: value }).then((data) => {
            //     callback()
            // }).catch((error) => {
            //     const json = JSON.parse(error.message)
            //     return callback(new Error(json.message))
            // })
        }
        // validatePassword: (rule, value, callback) => {
        //     if (this.utils.isEmpty(value)) {
        //         return callback(new Error('请输入登录密码'))
        //     }
        //     const reg = new RegExp(customRules._isPassword)
        //     if (!reg.test(value)) {
        //         return callback(new Error('6~20个字符，请使用字母、数字或特殊符号（除空格）的至少2种组合字符'))
        //     }
        //     callback()
        // },
        // validateRePassword: (rule, value, callback) => {
        //     if (this.utils.isEmpty(value)) {
        //         return callback(new Error('请再次输入您的登录密码'))
        //     }
        //     if (value !== this.form.password) {
        //         return callback(new Error('两次密码不一致'))
        //     }
        //     callback()
        // }
    }

    created() {
        // this.initPublicKey()
    }

    handleTo(path) {
        this.open(path)
    }

    async handleSubmit() {
        console.log(this.form.mobile.substring(this.form.mobile.length - 6))
        console.log(typeof this.form.mobile)
        this.btnLoading = true
        this.$refs[this.formName].validate((valid) => {
            if (valid) {
                let params = {
                    userName: this.form.username,
                    phone: this.form.mobile,
                    code: this.form.mobileVCode,
                    type: '12',
                    source: '0',
                    registerType: this.$route.query.registerType || 4
                }
                this.api.userApi.smsRegisterRegister(params).then((data) => {
                    if (data.code === 200) {
                        // this.setUser(data)
                        // let companyId = data.companyId
                        // Cookies.set('companyId', companyId, { domain: this.config.api.domain })
                        this.$router.push({ name: 'activation', params: { username: this.form.mobile, password: this.form.mobile.substring(this.form.mobile.length - 6), success: true } })
                    } else { 
                        this.$message({
                            message: data.message,
                            type: 'error'
                        })
                    }
                }).catch(() => {
                    this.btnLoading = false
                })
            }
            this.btnLoading = false
        })
    }

    handleRetry() {
        if (this.utils.isEmpty(this.form.mobile)) {
            this.$refs[this.formName].validateField('mobile')
            return
        }
        this.handleGetVerifyCode()
        this.verifyCodeText = `${this.count}s 重新获取`
        this.disabled = true
        this.timer = setInterval(() => {
            this.count--
            this.verifyCodeText = `${this.count}s 重新获取`
            if (this.count === 0) {
                this.verifyCodeText = `重新获取`
                clearInterval(this.timer)
                this.count = 60
                this.verifyCodeText = '获取验证码'
                this.disabled = false
            }
        }, 1000)
    }

    handleGetVerifyCode() {
        const { mobile } = this.form
        if (this.utils.isEmpty(mobile)) {
            this.$refs[this.formName].validateField('mobile')
            return
        }
        this.api.userApi.sendRegisterSms({
            phone: mobile,
            source: ''
        }).then((data) => {
            if (data.code !== 200) { 
                clearInterval(this.timer)
                this.count = 60
                this.verifyCodeText = '获取验证码'
                this.disabled = false
                return this.$message({
                    message: data.message,
                    type: 'warning'
                })
            }
            this.originVerifyCode = data.code
        }).catch(() => {
            clearInterval(this.timer)
            this.count = 60
            this.verifyCodeText = '获取验证码'
            this.disabled = false
        })
    }

    validVerifyCode(rule, value, callback) {
        if (this.utils.isEmpty(value)) {
            return callback(new Error('请输入验证码'))
        }
        if (this.utils.isEmpty(rule.item.mobile)) {
            return callback(new Error('请输入手机号码'))
        }
        callback()
    }

    validateMobile(rule, value, callback) {
        if (this.utils.isEmpty(value)) {
            return callback(new Error('请输入手机号码'))
        }
        const reg = new RegExp(customRules._isMobileReg)
        if (!reg.test(value)) {
            this.disabled = true
            return callback(new Error('请输入正确的手机号码'))
        }
        callback()

        this.disabled = false
    }
}



// WEBPACK FOOTER //
// ./src/views/page/main/registry/index.js